import React from 'react';
import Grid from '@mui/material/Grid';

interface CustomRowLabelsProps {
  data: any[];
}

const CustomRowLabels: React.FunctionComponent<CustomRowLabelsProps> = ({ data }) => {
  const rowLabels = data?.map((item) => item[0]?.display_name);
  rowLabels?.unshift(''); // Add an empty string for the first row to align with the spreadsheet

  return (
    <Grid container>
      {rowLabels?.map((label) => (
        <Grid
          item
          xs={12}
          key={label}
          sx={{
            height: '2em',
            borderTop: '1px solid #ddd',
            borderRight: '2px solid black',
            background: '#F5F5F5',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <p style={{ color: '#000', margin: 0 }}>{label || '\u00A0'}</p>
        </Grid>
      ))}
    </Grid>
  );
};

export default CustomRowLabels;
